import { StockCategoryFilter } from '../types/stockCategories';
import { CATEGORIES } from '../config/categoryConfig';

/**
 * Get the next category in the rotation based on priority order from categoryConfig.
 * Automatically updates when categories are added/removed/reordered in the central config.
 * Loops back to the first category after reaching the last.
 */
export const getNextCategory = (current: StockCategoryFilter | undefined): StockCategoryFilter => {
  if (!current) {
    // Default to first non-default category if no current category
    const nonDefault = CATEGORIES.find(cat => !cat.isDefault);
    return (nonDefault?.slug as StockCategoryFilter) || 'tech';
  }

  // Find current category index in priority order
  const currentIndex = CATEGORIES.findIndex(cat => cat.slug === current);

  if (currentIndex === -1) {
    // Fallback if current category not found (shouldn't happen)
    return CATEGORIES[0].slug as StockCategoryFilter;
  }

  // Get next category, wrapping around to start
  const nextIndex = (currentIndex + 1) % CATEGORIES.length;
  return CATEGORIES[nextIndex].slug as StockCategoryFilter;
};

/**
 * Get the previous category in the rotation based on priority order from categoryConfig.
 * Automatically updates when categories are added/removed/reordered in the central config.
 * Loops back to the last category when at the beginning of the list.
 */
export const getPreviousCategory = (current: StockCategoryFilter | undefined): StockCategoryFilter => {
  if (!current) {
    const nonDefault = CATEGORIES.find(cat => !cat.isDefault);
    return (nonDefault?.slug as StockCategoryFilter) || 'tech';
  }

  const currentIndex = CATEGORIES.findIndex(cat => cat.slug === current);

  if (currentIndex === -1) {
    return CATEGORIES[0].slug as StockCategoryFilter;
  }

  // Wrap back to last category when at the beginning of the list
  const previousIndex = currentIndex <= 0
    ? CATEGORIES.length - 1
    : currentIndex - 1;

  return CATEGORIES[previousIndex].slug as StockCategoryFilter;
};
